import {
  menu,
  popMenu,
  type PopupTarget,
} from '@blocksuite/affine-components/context-menu';

import type { Property } from '../../core/view-manager/property.js';
import type { SingleView } from '../../core/view-manager/single-view.js';
import type { FormulaPropertyData, FormulaRawValue } from './types.js';

/**
 * Opens the "Row formula" editor menu for one formula column and one row.
 * Shared by the formula cell (context menu / fx badge) and the row menu.
 */
export const openRowFormulaMenu = (
  anchor: PopupTarget,
  view: SingleView,
  property: Property<unknown, unknown, FormulaPropertyData>,
  rowId: string,
  setOverride: (value: string | null) => void
) => {
  const columns = view.propertiesRaw$.value.filter(
    column => column.id !== property.id
  );
  const rawOverride = property.valueGet(rowId) as FormulaRawValue | undefined;
  const currentExpression =
    (typeof rawOverride === 'string' ? rawOverride : undefined) ??
    property.data$.value.expression ??
    '';
  const displayExpression = currentExpression.replace(
    /\{([^}]+)\}/g,
    (_, id: string) =>
      `{${columns.find(column => column.id === id)?.name$.value ?? id}}`
  );
  const expressionInput = menu.input({
    placeholder: 'e.g. {Кол-во} * {Цена за ед.}',
    initialValue: displayExpression,
    onComplete: (value: string) => {
      const storedExpression = value.replace(
        /\{([^}]+)\}/g,
        (_, name: string) =>
          `{${
            columns.find(column => column.name$.value === name.trim())?.id ??
            name.trim()
          }}`
      );
      setOverride(storedExpression.trim() || null);
    },
  });

  popMenu(anchor, {
    options: {
      title: { text: 'Row formula' },
      items: [
        menu.group({ items: [expressionInput] }),
        ...(typeof rawOverride === 'string'
          ? [
              menu.action({
                name: 'Use column formula',
                select: () => setOverride(null),
              }),
            ]
          : []),
      ],
    },
  });
};
